
import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll, ModalController,ActionSheetController } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { NativeService } from '../../../../service/native.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { MzModalPage } from 'src/app/page/nestle/mz-modal/mz-modal.page';
import {WxjssdkService}from 'src/service/wxjssdk.service';
import { ReasonsDifferencesPage } from '../../reasons-differences/reasons-differences.page'
declare var app;
@Component({
  selector: 'app-gift-inventory-form',
  templateUrl: './gift-inventory-form.component.html',
  styleUrls: ['./gift-inventory-form.component.scss']
})
export class GiftInventoryFormComponent extends GridBaseCase {
  CustomInterfaceOptions: any = {
    header: '产品列表',
    // subHeader: 'Select your toppings',
    // message: '$1.00 per topping',
    // translucent: true
  };
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate = null;
  isSelectCahage: boolean = false;//是否多次点击
  // dataArrayList: Array<any> = [];
  productArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName: string = null;
  isAddProduct: boolean = true;//是否可以添加产品
  isSubmitData: boolean = true;//是否可以提交数据
  isAndroid4: boolean = false;//安卓4以下
  max: any;//最大日期
  isreturnGoods: boolean = false;//是否退货页面
  Remark: string = "";//消费者退货备注
  canUpdateFlag: number;
  imgUrlArr:Array<any> = [];
  isProductInventory:boolean=true;//是否可以提交盘库
  _type:any;//判断类型
  cravingforRemk:string = ""; // 差异原因
  reasonsforDifferencesList:Array<any>=[];
  base64Url = null;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController,
    public weixin:WxjssdkService,
    private actionSheet:ActionSheetController,
    private nativeservice: NativeService,
  ) {
    super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    if (this.pageName == "ReturnGoods") {//消费者退货
      this.isreturnGoods = true;
      this.baseService.arrayData = [];
    }
    this.isAndroid4 = this.com.Isandroidversion;
    this.max = this.com.TenTime;
    this.reasonsforDifferences();
  }
  EventLink(event, item) {
    // console.log(item);
    localStorage.setItem("information", JSON.stringify(item));
    this.com.setHistoryUrl();
    this.com.Go(event.url + item.id.value);
  }

  /**
   * 生产日期android5以下
   * @param item 选中的数据
   */
  EventClickTime(item) {
    // const that=this;
    // let val = item.orderCreateDate.value || "";
    // let obj = {};
    // if(val){
    //   const _val = val.replace(/-/g,"/");
    //   const _date = new Date(_val);
    //   const _month = _date.getMonth()+1;
    //   const _day = _date.getDate();
    //   const d = _date.getFullYear() + "-" + _month + "-" + _day;
    //   obj["value"]=d;
    // }else{
    //   const _date = new Date();
    //   obj["value"] = _date.getFullYear()+"-"+(_date.getMonth() + 1)+"-"+_date.getDate();
    // }
    // obj["format"]="yyyymmdd";
    // that.native.IosselectDateTime(obj).then(data=>{
    //   const _val = data.value.replace(/-/g,"/");
    //   const _date = new Date(_val);
    //   const _month = _date.getMonth()+1;
    //   const _day = _date.getDate();
    //   const d = _date.getFullYear() + "-" + (_month < 10?("0" + _month):_month) + "-" + (_day < 10?("0" + _day):_day);
    //   item.orderCreateDate.value = d;
    // }).catch(eror=>{
    // });
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.baseService.arrayData.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    }
      that.PageNumber++;
      this.LoadData(that.PageNumber);
  }
  LoadData(PageNumber) {
    let that = this;

    // 赠品盘库 console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "QueryGiftMonthInventory";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {

      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.baseService.arrayData = [];
        // that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {

        data.Status.Datas.forEach(function (item) {
          // item["a_Count"]=item["a_StockNum"];
          item["a_Count"]=null;
           item.color=false;// 是否变红色
           item.select= false;// 请选择是否显示
           item["seceltName"] = "请选择";
           item["objImgUrlArr"]= []; //数据提交处理
           item["imgUrlArr"]= []; // 页面显示
           item["cravingforRemk"] ="";
           item["Remark"] ="";
           item["FK_TBReasonsProductInventoryDifferences_ID"] ="";
           item["DamagedPictureUrl"]="";
          //  that.baseService.FixedSubmitBtn.isSubmitData=item.isapprove;
          //  that.baseService.FixedSubmitBtn.isSubmitData=false;
          

          that.baseService.arrayData.push(item);
        });
        that.isProductInventory = data.Status.isapprove;
        console.log( that.baseService.arrayData)
        console.log( that.isProductInventory)
        // 在日期范围内可以盘库  ErrorCode 1 可以盘库  2 不能盘库  isGiftOne  true  只能单次盘库
        that.canUpdateFlag = data.ResponseMessage.ErrorCode || 0;

        if(that.canUpdateFlag==1 && that.isProductInventory){
          that.baseService.FixedSubmitBtn.configName = "GiftInventoryForm";
          that.baseService.FixedSubmitBtn.isShow = true;
          that.baseService.FixedSubmitBtn.text = "提交";
          that.baseService.FixedSubmitBtn.type = 13;
          that.baseService.FixedSubmitBtn.isSubmitData=false;
        }
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.baseService.arrayData.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {     
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }



  /**
  * 下拉刷新数据
  * @param event
  */
  doRefresh(event) {
    const that = this;
    console.log("下拉率先你");
    console.warn("提示1");
    console.log(that.baseService.ListData);
    console.log("提示2");
    console.log(that.baseService.arrayData)
    // that.LoadData(1);

    // console.log(event);
    event.target.pullMax = 500;
    event.target.pullMin = 100;
    // console.log(this.ionRefresh);
    event.target.complete();
  }
   
  /**
   * 产品列表
   * @param event 
   */
  changeSelect(event) {

     
  }
  /**
   * 分销人
   * @param item 
   */
  onInput(item, event) {
    let that = this;
    console.log(event.target.value)
    // console.log(1);
    setTimeout(() => {
      if (event.target.value) {
       
        let numvalue: any = this.com.GetNumber(event.target.value);
        if(numvalue!== item.b_Stock ){
            item.select = true;
            item.color = true;
        }else if(numvalue== item.b_Stock){
          item.select = false;
          item.color = false;
        }
        if (numvalue) {
          item.a_Count = numvalue;
          event.target.value = numvalue;
        } else {
          item.a_Count = 0;
          event.target.value = 0;
        }
      } else {
        event.target.value = null;
        item.a_Count = 0;
      }
      // if (item.product_id.value) {
      //   if (!item.stock.value) {
      //     //  that.msg.Alert("盘库数量不能小于零，默认为1");
      //     item.stock.value = 0;
      //     event.target.value = 0;
      //   }
      // }
    }, 400);
  }
    /**
   * 差异原因
   */
     reasonsforDifferences(){
      let that = this;
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
        body.ConfigName = "TBReasonsProductInventoryDifferencesXML";
      // body.ConfigName="MemberManage";
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = 1;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      let _obj={};
      _obj["type"] =1;
      body.RequestBody = JSON.stringify(_obj);
      that.http.post(app.DEFAULTURL, body).then(data => {
  
        if (data.ResponseMessage.Success) {
         let  _reasonsforDifferencesList =  data.Status.Datas[0];
         that._type = _reasonsforDifferencesList;
          data.Status.Datas.forEach(items=>{
            items["isCheck"]= false;
            if(_reasonsforDifferencesList.a_ID == items.a_ID){
              items["isCheck"]= true;
            }
          });
          that.reasonsforDifferencesList= data.Status.Datas;
         
          console.log(that.reasonsforDifferencesList,"差异原因")
        }
  
      }).catch(error => {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
        that.loading = true;
        // console.log(error);
      });
    }
  async presentModaldifferences(item) {
    var that=this;
    // debugger;
     that.reasonsforDifferences();
    console.log(that.reasonsforDifferencesList,"差异原因")
    const modal = await this.modal.create({
      component: ReasonsDifferencesPage,
      cssClass: 'reasons-differences',
      componentProps: {
        'configName': this.pageName,
        "item":that.Remark,
        "fisttype":that._type,
        "reasonsforDifferenceslo":that.reasonsforDifferencesList
      }
    });
 
      await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data)
    if(data.seceltName){
      item.seceltName = data.seceltName;
      item.FK_TBReasonsProductInventoryDifferences_ID = data.FK_TBReasonsProductInventoryDifferences_ID
      item.cravingforRemk= data.cravingforRemk;
    }
    console.log(data.cravingforRemk)
   console.log(data.FK_TBReasonsProductInventoryDifferences_ID)
    // if(data&&data.request)
    // {
    //   that.Remark=data["result"]||"";
    //   arrayDataList.forEach((item)=>{
    //     item["Remark"]=that.Remark;
    //   });
    //   // that.requestData(arrayDataList,true);
    // }else{
    //   return;
    // }

  }
  cleashideModal(item){
    const that =this;
    that.cravingforRemk ="";
    item["FK_TBReasonsProductInventoryDifferences_ID"] =""
    item.seceltName = "请选择"
    that.reasonsforDifferences();
  }
  Eventdatetime(event, item) {
    item.orderCreateDate.value = event.detail.value;
    // console.log(item);
    // console.log(event);
  }
  /**
   * 
   */
    /**
   * 拍照页面
   */
     async EventClickCamra(item){
      const that=this;
      if(that.com.IsWeixinBrowser){
        that.weixin.GetWxCamera().then(body=>{
          console.log(body,"拍照返回成功");
          if(body.ResponseMessage.Success){
            let obj={};
            let objStr={};// 拼接字符串处理
            let _imgURL=(app.FileUoloadUrl+body.Status[0].FileName).replace(app.ImagePlaceholder,app.SmallImageType);
            console.log(_imgURL);
            obj["url"] = _imgURL;
            // objStr["FileName"] = body.Status[0].FileName;
           let objStrArr=body.Status[0].FileName;
            item.imgUrlArr.push(obj);
            item.objImgUrlArr.push(objStrArr);
                console.log(item.imgUrlArr,"上传的照片")
          }else{
            that.msg.Alert(body.ResponseMessage.ErrorMessage);
          }
        }).catch(err=>{
          console.log(err,"拍照返回失败");
          that.msg.Alert("图片上传失败");
        });
        return;
      }
    }
    /**
     * 删除/查看照片
     * @param item 
     * @param i 
     */
   async EventClickEdite(item,items,i){
     const that=this;
     let _option1 = {
      // header: '',
      buttons: [{
        text: '预览',
        handler: () => {
          // console.log('预览');
          that.imgPreview(item,items,i);
        }
      }, {
        text: '删除',
        handler: () => {
          item.imgUrlArr.splice(i,1);
       
        }
      }, {
        text: '取消',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    };
      const actionSheet = await that.actionSheet.create(_option1);
      await actionSheet.present();
    }
    /**
     * 
     * @param i 查看照片
     */
    imgPreview(item,items,i) {
      let that = this;
      let url = [];
      item.imgUrlArr.forEach(ite=>{
        let u = null;
        if(ite.url.indexOf("data:") > -1){
          u = ite.url
        }else{
          u = ite.url.trim().replace(app.SmallImageType,app.BigImageType);
        }
        url.push(u);
      })
      let ImgPreview = {
        imgUrl: url,
        index: i
      }
      that.com.setHistoryUrl(false);
      // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
      // that.router.navigate(["/tabs/contact/ImgPreview"]);
      that.com.Go("/tabs/contact/ImgPreview/"+that.com.getNowDatetime,{
        ImgPreview: JSON.stringify(ImgPreview)
      });
    }

  /**
   * 提交数据
   */
  EventSubmitClick() {
    const that=this;
    let requestObj = {}
    let postJson = [];
    // debugger;
    const newList = [];
    that.baseService.arrayData.forEach(item => {
      if(item.a_Count!== null){
        console.log(item.imgUrlArr,"测试数据");
        console.log()
        let curr_obj = {};
        curr_obj["ID"] = item.c_ID;
        curr_obj["StockNum"] = item.a_Count;
        curr_obj["BeforeInventory"] = item.b_Stock;
        curr_obj["DifferenceReason"]=item.cravingforRemk;//备注信息
        curr_obj["FK_TBReasonsProductInventoryDifferences_ID"] = item.FK_TBReasonsProductInventoryDifferences_ID;
        console.log( item.objImgUrlArr);
        const newList = [];
        item.objImgUrlArr.forEach(arg => {
          　　newList.push(arg);
          })
          curr_obj["DamagedPictureUrl"] = newList.join(",");
       console.log(item.DamagedPictureUrl,"拼接的数据")
        postJson.push(curr_obj);
      }
    
    });
    requestObj["Gifts"] = postJson;
    // requestObj["DifferenceReason"] = "";
    console.log(requestObj,"数据数据");
    if (requestObj['Gifts'].length==0) {
      that.msg.Alert("未填写库存数量");
      // this.presentModal(this.baseService.arrayData,requestObj);
    }else{
      console.log("submit", requestObj);
      this.RequestEvent(requestObj);
    }
    // if (this.baseService.arrayData.find(n => n.b_Stock != n.a_Count)) {
    //   this.presentModal(this.baseService.arrayData,requestObj);
    // }else{
    //   console.log("submit", requestObj);
    //   this.RequestEvent(requestObj);
    // }
  }

  async presentModal(arrayData:Array<any>,requestObj:any) {
    const modal = await this.modal.create({
      component: MzModalPage,
      cssClass: 'my-custom-class',
      componentProps: {
        'configName': this.pageName,
      }
    });

    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data && data.request) {
      let remark = data["result"] || "";
      console.log("modalww", this.baseService.arrayData);
       requestObj["DifferenceReason"] = remark;
         this.RequestEvent(requestObj);
      console.log("submit", requestObj);
    } else {
      return;
    }
  }


  RequestEvent(requestObj:any){
    var that=this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "AddGiftMonthInventory";
    body.OpType = "add";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let ismodal:boolean=false;//是否盘库数量不对  没有写备注
    requestObj["Gifts"].forEach(item=>{
      if(item.StockNum !== item.BeforeInventory ){
        if(!item.FK_TBReasonsProductInventoryDifferences_ID){
          item.color=true;
          item.select=true;
          ismodal=true;
        }
      }
    })
    if(ismodal){
      that.msg.Alert("盘库库存与实际库存不一致，请选择差异原因");
      return;
    }
    body.RequestBody = JSON.stringify(requestObj);
    that.msg.Loading("请稍后...").then(loads => {
      that.http.post(app.DEFAULTURL, body).then(data => {
        setTimeout(function(){
          loads.dismiss();
        },100);
        if (data.ResponseMessage.Success) {
          that.msg.Alert("提交成功").then(res=>{
            if(res){
             that.com.goBack();
            }
         });
        //  that.msg.Alert("操作成功！");
         that.LoadData(1);
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(err => {
        loads.dismiss();
        that.msg.Alert("网络异常，请稍后再试！");
      });
     
    })
  }
   

  //备注输入
  RemarkInput(e) {
    let that = this;
    if (e && e.target.value) {
      if (e.target.value.length > 300) {
        e.target.value = e.target.value.substr(0, 300);
        that.Remark = e.target.value;
      }
    }
  }
}
